import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';

const SimpleCell = ({
  children,
  className,
  collapsing,
  colSpan,
  content,
  disabled,
  textAlign,
  title,
}) => (
  <Table.Cell
    className={clsx('aridhia-simple-cell', className)}
    collapsing={collapsing}
    colSpan={colSpan}
    disabled={disabled}
    textAlign={textAlign}
    title={title || content}
  >
    {children}
    {content}
  </Table.Cell>
);

export default SimpleCell;
